import { Fragment } from "react";

/* Formats */
// date
export const date = (str) => {

    const date = new Date(str);

    return (
        `${('0' + date.getDate()).slice(-2)}/` +
        `${('0' + (date.getMonth() + 1)).slice(-2)}/` +
        `${('' + date.getFullYear()).slice(2)} `
    )
}

// date time
export const dateTime = (str) => {

    const date = new Date(str);

    return (
        `${('0' + date.getDate()).slice(-2)}/` +
        `${('0' + (date.getMonth() + 1)).slice(-2)}/` +
        `${('' + date.getFullYear()).slice(2)} ` +
        `${('0' + date.getHours()).slice(-2)}:` +
        `${('0' + date.getMinutes()).slice(-2)}`
    )
}

// date time local
export const dateTimeLocal = (str) => {
    const date = new Date(str);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

// date format
export const dateFormat = (str) => {

    const days = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ];
    const months = {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
    }

    const d = new Date(str);
    const year = d.getFullYear();
    const date = d.getDate();
    const monthName = months[d.getMonth()];
    const dayName = days[d.getDay()];

    return `${dayName}, ${date} ${monthName} ${year}`;
};

// currency
export const currencyFormat = (num, symbol, inPence = false, numPlaces = 2) => {
    symbol = symbol || '£';
    if (inPence) {
        num = num / 100; // convert to pounds
    }
    return symbol + num.toFixed(numPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

// dates
export const timeSince = (d) => {
    const date = new Date(d);
    const today = new Date();
    const dif = (today.getTime() - date.getTime());

    // right now
    if (dif < 1000) {
        return 'right now'
    }
    // > 1 hour
    else if (dif <= 3600000) {
        const minutes = Math.floor(dif / (60 * 1000));
        //return (minutes > 1) ? minutes + ' mins ago' : minutes + ' min ago';
        return `${minutes} min${(minutes > 1) ? 's' : ''} ago`
    }
    // hours
    else if (dif <= 43200000) {
        const hours = Math.floor(dif / (60 * 60 * 1000));
        //return (hours > 1) ? hours + ' hours ago' : hours + ' hour ago';
        return `${hours} hour${(hours > 1) ? 's' : ''} ago`;
    }
    // days
    else if (dif <= 172800000) {
        const days = Math.round(dif / (60 * 60 * 24 * 1000));
        //return (days > 1) ? days + ' days ago' : days + ' day ago';
        return `${days} day${(days > 1) ? 's' : ''} ago`;
    }

    return (
        `${('0' + date.getDate()).slice(-2)}/` +
        `${('0' + (date.getMonth() + 1)).slice(-2)}/` +
        `${('' + date.getFullYear()).slice(2)} ` +
        `${('0' + date.getHours()).slice(-2)}:` +
        `${('0' + date.getMinutes()).slice(-2)}`
    )
}


// data
export const bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

// general

export const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
}

export const formatAddress = (addLines, addBr = false) => {
    if (!Array.isArray(addLines)) return '';

    // Remove empty strings and trim whitespace
    const filteredLines = addLines.filter(line => line.trim() !== '');

    // Return an array of JSX elements
    return filteredLines.map((line, index) => (
        <Fragment key={index}>
            {line}
            {index < filteredLines.length - 1 && (
                addBr ? <>,<br /></> : ', '
            )}
        </Fragment>
    ));
}

// validation
function supportsValidity() {
    var i = document.createElement('input');
    return typeof i.validity === 'object';
}

function strip(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

export const validate = (str, type) => {
    var type = type || 'strip';
    var pString = /^[a-zA-Z]+$/;
    var pName = /^[a-zA-Z ,.'-]+$/i;
    var pNumber = /^\d+$/;
    var pEmail = /[a-z0-9!#$%&'*+\/=?^_{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9-]*[a-z0-9]/;
    var pPhone = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
    var pURL = /((https?|ftp|file|ssh):\/\/)?(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?/;

    switch (type) {
        case 'strip': {
            return strip(str);
        }
        case 'phone': {
            str = (pPhone.test(str)) ? str : '';
            return str;
        }
        case 'letters': {
            str = (pString.test(str)) ? str : '';
            return str;
        }
        case 'name': {
            str = (pName.test(str)) ? str : '';
            return str;
        }
        case 'number': {
            str = (pNumber.test(str)) ? str : '';
            return str;
        }
        case 'email': {
            str = (pEmail.test(str)) ? str : '';
            return str;
        }
        case 'url': {
            str = (pURL.test(str)) ? str : '';
            return str;
        }
    }
}